import DropdownButton from "@/components/DropdownButton";
import { ROLE } from "@/config/role";
import { Assessor } from "@/schema/console/assessors/Assessor";
import useAssessorDialog from "@/src/console/(auth)/assessors/_hooks/useAssessorDialog";
import { useTranslation } from "react-i18next";

interface AssessorTableRowActionsProps {
  assessor: Assessor;
}

function AssessorTableRowActions({ assessor }: AssessorTableRowActionsProps) {
  const { t } = useTranslation();
  const { setDialog } = useAssessorDialog();
  return (
    <DropdownButton
      items={[
        {
          item: t("edit"),
          key: "edit",
          onClick: () =>
            setDialog({
              assessor,
              type: "update",
            }),
        },
        {
          disabled: assessor.role === ROLE.ADMIN,
          item: t("assign-company"),
          key: "assign-company",
          onClick: () =>
            setDialog({
              assessor,
              type: "assign-company",
            }),
        },
        {
          item: t("change-password"),
          key: "change-password",
          onClick: () =>
            setDialog({
              assessor,
              type: "change-password",
            }),
        },
        {
          item: <span className="text-red-500">{t("delete")}</span>,
          key: "delete",
          onClick: () =>
            setDialog({
              assessor,
              type: "delete",
            }),
        },
      ]}
    />
  );
}

export default AssessorTableRowActions;
